import {Injectable, EventEmitter} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {formLog} from '../services/debug-logger';

@Injectable({
  providedIn: 'root'
})
export class ValidationInfoService {
  private currenttabIsValid: boolean;

  public onUserUpdate = new EventEmitter<any>();

  constructor() {
    this.currenttabIsValid = true;
  }

  public getValidateState(): boolean {
    return this.currenttabIsValid;
  }

  public validate(validateState: boolean, component: string) {
    formLog.log(`[${component}] isValid:`, validateState);
    this.currenttabIsValid = this.currenttabIsValid && validateState;
  }

  public resetAndValidate(payload: any = {}) {
    this.currenttabIsValid = true;
    this.onUserUpdate.emit(payload);
  }

  markAllFieldsAsTouched(form: FormGroup, component: string = 'form') {
    Object.keys(form.controls).forEach(key => {
      form.get(key).setErrors(null);
      form.get(key).markAsTouched();
      form.get(key).updateValueAndValidity();
    });

    formLog.invalid(component, form);
  }
}
